import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: '[app-dropdown-button-item]',
  templateUrl: './dropdown-button-item.component.html',
  styleUrls: ['./dropdown-button-item.component.scss']
})
export class DropdownButtonItemComponent implements OnInit {

  @Input()
  hasCheckbox = false;

  @Input()
  titleKey = '';

  constructor() {
  }

  ngOnInit() {
  }

}
